<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl('/index')">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        简介
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <div class="right">
        <!-- <van-icon name="manager" size="21" /> -->
      </div>
    </div>
    <div class="padding">
      <van-loading size="24px" v-show="showL" style="text-align:center">加载中...</van-loading>
      <div class="infos" v-html="content"></div>
    </div>
  </div>
</template>
<script>
import { Icon, Field, Loading } from "vant";
import { intro } from "@/api/apiData";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Loading.name]: Loading,
  },
  data() {
    return {
      content: "",
      showL: true,
    };
  },
  mounted() {
    this.getIntro();
  },
  methods: {
    toUrl(u) {
      this.$router.push(u);
    },
    getIntro() {
      intro().then((res) => {
        if (res.status == 1) {
          // var serverSrc = 'http://cjr.cn'
          // var srcReg = /src=([\'\"]?([^\'\"]*)[\'\"]?)/gi;
          // res.data.content = res.data.content.replace(
          //   srcReg,
          //   "src='" + serverSrc + "$2" + "'"
          // );
          this.content = res.data.content;
          this.showL = false;
        } else {
          alert(res.message);
        }
      });
    },
  },
};
</script>
<style scoped>
.infos{
      margin: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/page/intro.vue